import {RootStore} from '../index';
import {action, makeAutoObservable} from "mobx"
import Request1cModel from "../../model/Request1cModel";


// noinspection DuplicatedCode
export class PageRegTradePointStore {

    private rootStore: RootStore | undefined;

    public inputs = {
        cityId: {
            code: 'cityId',
            type: "text",
            title: 'Город',
            tooltip: 'Город',
            option: [],
            error: '',
            value: '',
            server: true,
        },
        fullNameOrg: {
            code: 'fullNameOrg',
            type: "text",
            title: 'Название торговой точки',
            tooltip: 'Название торговой точки',
            error: '',
            value: '',
            server: true,
        },
        tradePointAddress: {
            code: 'tradePointAddress',
            type: "text",
            title: 'Адрес торговой точки',
            tooltip: 'Полный адрес торговой точки',
            error: '',
            value: '',
            required:true,
            server: true,
        },
        phone: {
            code: 'phone',
            type: "text",
            title: 'Телефон',
            tooltip: 'Телефон',
            error: '',
            value: '',
            server: true,
            isMask: true,
            mask: '+375 (99) 999-99-99'
        }
    };

    public error: string = '';
    public redirect: boolean = false;

    constructor(rootStore?: RootStore) {
        makeAutoObservable(this);
        this.rootStore = rootStore;
    }

    init() {
        this.redirect = false;
        this.setDefaultData();
    }

    setDefaultData(){
       this. inputs = {
            cityId: {
                code: 'cityId',
                type: "text",
                title: 'Город',
                tooltip: 'Город',
                option: [],
                error: '',
                value: '',
                server: true,
            },
            fullNameOrg: {
                code: 'fullNameOrg',
                type: "text",
                title: 'Название торговой точки',
                tooltip: 'Название торговой точки',
                error: '',
                value: '',
                server: true,
            },
            tradePointAddress: {
                code: 'tradePointAddress',
                type: "text",
                title: 'Адрес торговой точки',
                tooltip: 'Полный адрес торговой точки',
                error: '',
                required:true,
                value: '',
                server: true,
            },
            phone: {
                code: 'phone',
                type: "text",
                title: 'Телефон',
                tooltip: 'Телефон',
                error: '',
                value: '',
                server: true,
                isMask: true,
                mask: '+375 (99) 999-99-99'
            }
        };
    }

    falseRedirect = () => {
        this.redirect = false;
    }

    @action
    checkCity(isMessage = false) {
        let result = '';
        let val = this.inputs.cityId.value;
        // @ts-ignore
        let data = this.inputs.cityId.option.filter(item => item.name === val);
        if (!data.length) {
            if(isMessage){
                this.inputs.cityId.error = 'Выберите город из списка!';
            }
            result = '';
        } else {
            // @ts-ignore
            result = data[0].id;
        }
        return result;
    }


    @action
    onSubmitForm(e: { preventDefault: () => void; }) {
        e.preventDefault();
        let data = [];
        for (let code in this.inputs) {
            // @ts-ignore
            let item = this.inputs[code];
            // @ts-ignore
            if (item.server) {
                data.push(item);
            }
        }
        let dt: any = {};
        data.map((item: any) => {
            dt[item.code] = item.value;
            return item;
        });
        let id = this.checkCity(true);
        if (id) {
            dt['cityId'] = id;
            dt['isProcessed'] = false;
            dt['type'] = 'tradepointReg';
            dt['siteId'] = this.rootStore?.mainStore?.user?.siteId;
            Request1cModel.createTradePoint(
                dt,
                this.setSubmit,
                this.setError
            );
        }
        return false;
    }

    @action
    setSubmit = (result: any) => {
        this.redirect = true;
    }


    @action
    onChangeInput = (e: { target: { value: string; }; }, item: any) => {
        item.value = e.target.value;
    }

    @action
    onChangeInputCity = (e: { target: { value: string; }; }, item: any) => {
        item.value = e.target.value;
        if (item.value.length > 2) {
            if (!this.checkCity()) {
                this.getCity(item.value);
            }else{
                this.inputs.cityId.error='';
            }
        } else {
            item.option = [];
        }
    }

    @action getCity(q: string) {
        Request1cModel.getCity(q, this.setOptionCity, this.setError)
    }


    @action setOptionCity = (result: any) => {
        this.inputs.cityId.option = result.data;
    }

    @action
    setError = (error: any) => {
        if (
            error !== undefined &&
            error.response !== undefined &&
            error.response.data !== undefined &&
            error.response.data.message !== undefined
        ) {
            this.error = String(error.response.data.message);
        } else if (
            error !== undefined &&
            error.response !== undefined &&
            error.response.data !== undefined &&
            Array.isArray(error.response.data)
        ) {
            let el = {
                error: ''
            };
            error.response.data.map((item: any) => {
                // @ts-ignore
                el = this.inputs[item.code];
                if (el !== undefined) {
                    el.error = item.error;
                }
                return item;
            });
        } else if (
            error !== undefined &&
            error.response !== undefined &&
            error.response.data !== undefined &&
            !Array.isArray(error.response.data)
        ) {
            return String(error.response.data);
        }
    }

}